import { createAction, props } from '@ngrx/store';
import { PayOnAccountPaymentDetails } from '../../models';
import {
  PaymentPreviewErrorPayload,
  PayOnAccountPaymentPreviewV1Response,
} from '@arc/unified-payments-frontend/shared-payment';
import { ExpirationDate } from '@arc/unified-payments-frontend/date-utils';

export const PaymentDetailsSubmittedAction = createAction(
  '[Pay On Account] Payment Details Submitted Action',
  props<{ paymentDetails: PayOnAccountPaymentDetails }>(),
);

export const PaymentPreviewSurchargeUpdatedAction = createAction(
  '[Pay On Account] Payment Preview Surcharge Updated Action',
  props<{
    paymentPreview: PayOnAccountPaymentPreviewV1Response;
  }>(),
);

export const SurchargeAmountErrorAction = createAction(
  '[Pay On Account] Surcharge Amount Error Action',
  props<{
    payload: PaymentPreviewErrorPayload;
  }>(),
);

export const OpenAddPaymentMethodDialog = createAction(
  '[Pay On Account] Open Add Payment Method Dialog',
);

export const closeAddPaymentMethodDialog = createAction(
  '[Pay On Account Select Payment Method] Close Add Payment Method Dialog',
);

export const IsScheduledPaymentDateUpdated = createAction(
  '[Pay On Account] Is Scheduled Payment Date Updated',
  props<{
    isScheduledPaymentDate: boolean;
  }>(),
);

export const cvvUpdated = createAction(
  '[Pay On Account Select Payment Method] CVV Updated',
  props<{ cvv: string }>(),
);

export const paymentAccountExpirationDateUpdated = createAction(
  '[Select Payment Method] Payment Account Expiration Date Updated',
  props<{ expirationDate: ExpirationDate }>(),
);

export const validateAccountIdentifierSuccess = createAction(
  '[Payment Details PaymentInfo] Validate Account Identifier Success',
);

export const validateAccountIdentifierError = createAction(
  '[Payment Details PaymentInfo] Validate Account Identifier Error',
  props<{ accountIdentifierInvalid: boolean }>(),
);
